export default __webpack_public_path__ + "static/media/SLIDE_CAMELLON_4.9de14036.jpg";